/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalPatient_requestDeletePortalPatient } from '../models/api_portalPatient_requestDeletePortalPatient';
import type { api_portalPatient_requestGetPortalPatient } from '../models/api_portalPatient_requestGetPortalPatient';
import type { api_portalPatient_requestImportCsv } from '../models/api_portalPatient_requestImportCsv';
import type { api_portalPatient_requestListFiles } from '../models/api_portalPatient_requestListFiles';
import type { api_portalPatient_requestListPortalPatients } from '../models/api_portalPatient_requestListPortalPatients';
import type { api_portalPatient_requestSavePortalPatient } from '../models/api_portalPatient_requestSavePortalPatient';
import type { api_portalPatient_requestSearchPortalPatients } from '../models/api_portalPatient_requestSearchPortalPatients';
import type { api_portalPatient_requestUpdateIsAccept } from '../models/api_portalPatient_requestUpdateIsAccept';
import type { api_portalPatient_requestUploadCsv } from '../models/api_portalPatient_requestUploadCsv';
import type { api_portalPatient_requestUploadFile } from '../models/api_portalPatient_requestUploadFile';
import type { api_portalPatient_responseDeletePortalPatient } from '../models/api_portalPatient_responseDeletePortalPatient';
import type { api_portalPatient_responseGetMasterData } from '../models/api_portalPatient_responseGetMasterData';
import type { api_portalPatient_responseGetPortalPatient } from '../models/api_portalPatient_responseGetPortalPatient';
import type { api_portalPatient_responseImportCsv } from '../models/api_portalPatient_responseImportCsv';
import type { api_portalPatient_responseListFiles } from '../models/api_portalPatient_responseListFiles';
import type { api_portalPatient_responseListPortalPatients } from '../models/api_portalPatient_responseListPortalPatients';
import type { api_portalPatient_responseSavePortalPatient } from '../models/api_portalPatient_responseSavePortalPatient';
import type { api_portalPatient_responseSearchPortalPatients } from '../models/api_portalPatient_responseSearchPortalPatients';
import type { api_portalPatient_responseUpdateIsAccept } from '../models/api_portalPatient_responseUpdateIsAccept';
import type { api_portalPatient_responseUploadCsv } from '../models/api_portalPatient_responseUploadCsv';
import type { api_portalPatient_responseUploadFile } from '../models/api_portalPatient_responseUploadFile';
import type { common_BaseResponse } from '../models/common_BaseResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalPatientService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Delete PortalPatient
     * Delete PortalPatient
     * @returns api_portalPatient_responseDeletePortalPatient responseDeletePortalPatient
     * @throws ApiError
     */
    public postPortalPatientDelete({
        body,
    }: {
        /**
         * requestDeletePortalPatient
         */
        body: api_portalPatient_requestDeletePortalPatient,
    }): CancelablePromise<api_portalPatient_responseDeletePortalPatient> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Download portal patient sample csv
     * Download portal patient sample csv
     * @returns common_BaseResponse OK
     * @throws ApiError
     */
    public postPortalPatientDownloadSampleCsv(): CancelablePromise<common_BaseResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/download_sample_csv',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalPatient
     * Get PortalPatient
     * @returns api_portalPatient_responseGetPortalPatient responseGetPortalPatient
     * @throws ApiError
     */
    public postPortalPatientGet({
        body,
    }: {
        /**
         * requestGetPortalPatient
         */
        body: api_portalPatient_requestGetPortalPatient,
    }): CancelablePromise<api_portalPatient_responseGetPortalPatient> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Master Data
     * 利用者関連機能で使用するマスターデータを取得する
     * @returns api_portalPatient_responseGetMasterData responseGetMasterData
     * @throws ApiError
     */
    public postPortalPatientGetMasterData(): CancelablePromise<api_portalPatient_responseGetMasterData> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/get_master_data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Import portal patient csv
     * Import portal patient csv
     * @returns api_portalPatient_responseImportCsv responseImportCsv
     * @throws ApiError
     */
    public postPortalPatientImportCsv({
        body,
    }: {
        /**
         * requestImportCsv
         */
        body: api_portalPatient_requestImportCsv,
    }): CancelablePromise<api_portalPatient_responseImportCsv> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/import_csv',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List PortalPatient
     * List PortalPatient
     * @returns api_portalPatient_responseListPortalPatients responseListPortalPatients
     * @throws ApiError
     */
    public postPortalPatientList({
        body,
    }: {
        /**
         * requestListPortalPatients
         */
        body: api_portalPatient_requestListPortalPatients,
    }): CancelablePromise<api_portalPatient_responseListPortalPatients> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Files
     * 指定された利用者に紐づくファイル一覧を返します。
     * @returns api_portalPatient_responseListFiles responseListFiles
     * @throws ApiError
     */
    public postPortalPatientListFiles({
        body,
    }: {
        /**
         * requestListFiles
         */
        body: api_portalPatient_requestListFiles,
    }): CancelablePromise<api_portalPatient_responseListFiles> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/list_files',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save PortalPatient
     * Save PortalPatient（id=nullでInsert、id指定でUpdate）
     * @returns api_portalPatient_responseSavePortalPatient responseSavePortalPatient
     * @throws ApiError
     */
    public postPortalPatientSave({
        body,
    }: {
        /**
         * requestSavePortalPatient
         */
        body: api_portalPatient_requestSavePortalPatient,
    }): CancelablePromise<api_portalPatient_responseSavePortalPatient> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Search PortalPatient
     * 利用者を検索する
     * @returns api_portalPatient_responseSearchPortalPatients responseSearchPortalPatients
     * @throws ApiError
     */
    public postPortalPatientSearch({
        body,
    }: {
        /**
         * requestSearchPortalPatients
         */
        body: api_portalPatient_requestSearchPortalPatients,
    }): CancelablePromise<api_portalPatient_responseSearchPortalPatients> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/search',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update IsAccept
     * Update IsAccept
     * @returns api_portalPatient_responseUpdateIsAccept responseUpdateIsAccept
     * @throws ApiError
     */
    public postPortalPatientUpdateIsAccept({
        body,
    }: {
        /**
         * requestUpdateIsAccept
         */
        body: api_portalPatient_requestUpdateIsAccept,
    }): CancelablePromise<api_portalPatient_responseUpdateIsAccept> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/update_is_accept',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload portal patient csv
     * Upload portal patient csv
     * @returns api_portalPatient_responseUploadCsv responseUploadCsv
     * @throws ApiError
     */
    public postPortalPatientUploadCsv({
        body,
    }: {
        /**
         * requestUploadCsv
         */
        body: api_portalPatient_requestUploadCsv,
    }): CancelablePromise<api_portalPatient_responseUploadCsv> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/upload_csv',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Upload File (PDF、jpg、jpeg、png)
     * 利用者に関連するファイル(PDF、jpeg、png、doc、ppt、xls)をアップロードする
     * @returns api_portalPatient_responseUploadFile responseUploadFile
     * @throws ApiError
     */
    public postPortalPatientUploadFile({
        body,
    }: {
        /**
         * requestUploadFile
         */
        body: api_portalPatient_requestUploadFile,
    }): CancelablePromise<api_portalPatient_responseUploadFile> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_patient/upload_file',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                422: `ウイルススキャン失敗`,
                500: `Internal Server Error`,
            },
        });
    }
}
